import { createReducer, Reducer } from "@reduxjs/toolkit";
import { Pageable } from "../../services/pageable";
import { RemoteResource } from "../common/fetchable";
import { Fetchable, EmptyFetchable } from "../common/fetchable/helpers";
import { LaunchConfigurationsActions } from "./actions";
import { LaunchConfigurationsDTO } from "./models/dto";

export namespace LaunchConfigurations {
  export const launchConfigurations: RemoteResource<
    LaunchConfigurationsDTO.Responses.GetAll.T,
    LaunchConfigurationsDTO.Responses.GetAll.T,
    Pageable.T<keyof LaunchConfigurationsDTO.Responses.GetSingle.T>
  > = {
    fetch: LaunchConfigurationsActions.setPagination,
    updateStore: LaunchConfigurationsActions.setLaunchConfigurations,
    selector: (store) => store.launchConfigurations.launchConfigurations.data,
  };
}

/**
 * Interface used for Redux Store
 */
export interface LaunchConfigurations {
  launchConfigurations: {
    data: Fetchable<LaunchConfigurationsDTO.Responses.GetAll.T>;
    pagination: Pageable.T<keyof LaunchConfigurationsDTO.Responses.GetSingle.T>;
  };
  launchConfigurationMap: Record<
    string,
    LaunchConfigurationsDTO.Responses.GetSingle.T | "LOADING"
  >;
  newLaunchConfigurationForm: Partial<LaunchConfigurationsDTO.Requests.SetSingle.T>;
}

const initialState: LaunchConfigurations = {
  launchConfigurations: {
    data: EmptyFetchable,
    pagination: {},
  },
  launchConfigurationMap: {},
  newLaunchConfigurationForm:
    LaunchConfigurationsDTO.Requests.SetSingle.defaults,
};

// Reducer
export const launchConfigurationsReducer: Reducer<
  LaunchConfigurations,
  LaunchConfigurationsActions.Actions
> = createReducer(initialState, (builder) => {
  builder
    .addCase(LaunchConfigurationsActions.setPagination, (state, action) => {
      state.launchConfigurations.pagination = action.payload;
      state.launchConfigurations.data = {
        status: "loading",
      };
    })
    .addCase(
      LaunchConfigurationsActions.setLaunchConfigurations,
      (state, action) => {
        //TODO: use id as link to map
        state.launchConfigurations.data = action.payload;
        if (action.payload.status === "ready") {
          action.payload.data.content.forEach((p) => {
            state.launchConfigurationMap[p.id] = p;
          });
        }
      }
    )
    .addCase(LaunchConfigurationsActions.resetLaunchConfigurations, (state) => {
      state.launchConfigurations.data = EmptyFetchable;
      state.launchConfigurations.pagination = {};
      state.launchConfigurationMap = {};
    })
    .addCase(
      LaunchConfigurationsActions.setSingleLaunchConfiguration,
      (state, action) => {
        state.launchConfigurationMap[action.payload.id] = action.payload.result;
      }
    )
    .addCase(
      LaunchConfigurationsActions.setNewLaunchConfigurationSection,
      (state, action) => {
        state.newLaunchConfigurationForm = {
          ...state.newLaunchConfigurationForm,
          ...action.payload,
        };
      }
    )
    .addCase(
      LaunchConfigurationsActions.resetAllNewLaunchConfigurationSection,
      (state, action) => {
        state.newLaunchConfigurationForm = {};
      }
    )
    .addCase(
      LaunchConfigurationsActions.getSingleLaunchConfiguration,
      () => {}
    ); // Does nothing
});
